import { SkeletonLoader } from "./SkeletonLoader";
import "./SummaryCard.css";

type SummaryCardProps = {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: string;
  variant?: "default" | "success" | "danger" | "warning";
  loading?: boolean;
};

export function SummaryCard({
  title,
  value,
  subtitle,
  icon,
  variant = "default",
  loading,
}: SummaryCardProps) {
  return (
    <div class={`summary-card summary-card--${variant}`}>
      <div class="summary-card__header">
        {icon && (
          <span class="summary-card__icon" aria-hidden="true">
            {icon}
          </span>
        )}
        <h3 class="summary-card__title">{title}</h3>
      </div>
      {loading ? (
        <SkeletonLoader type="card" />
      ) : (
        <>
          <p class="summary-card__value">{value}</p>
          {subtitle && <p class="summary-card__subtitle">{subtitle}</p>}
        </>
      )}
    </div>
  );
}
